import * as yup from 'yup';
import { isValidYupSchema, yupUtils } from '../../utils/yup/utils';
import { FORM_QUESTION_TYPES, FORM_RESPONSE_TYPES, FormQuestion } from '../types/forms';
import { ProjectErrors, ProjectErrorType } from '../../utils/errors/types';
import { getProjectErrorForCode, getProjectErrorFromRawError, isProjectError } from '../../utils/errors';

export const MinimalFormQuestionSchema = yup.object().shape({
  text: yupUtils.stringRequired('Question text is required'),
});

export const FormQuestionSchema = yup.object().shape({
  id: yupUtils.stringRequired(),
  text: yupUtils.stringRequired('Question text is required'),
  key: yupUtils.stringOptionalNullable,
  extraData: yup.object({
    quoteAuthor: yupUtils.stringOptionalNullable,
    quoteText: yupUtils.stringOptionalNullable,
    pillar: yupUtils.stringOptionalNullable,
  }),
  presentationText: yupUtils.stringOptionalNullable,
  responses: yupUtils.arrayOptionalNullableOf(
    yup
      .object({
        key: yupUtils.stringRequired(),
        type: yupUtils.stringRequiredOneOf(FORM_RESPONSE_TYPES),
        description: yupUtils.stringOptionalNullable,
        placeholder: yupUtils.stringOptionalNullable,
        options: yupUtils.arrayOptionalNullableOf(
          yup.object({ value: yupUtils.stringRequired(), text: yupUtils.stringRequired() }),
        ),
      })
      .default({ quoteAuthor: yupUtils.stringOptionalNullable, quoteText: yupUtils.stringOptionalNullable }),
  ),
  type: yupUtils.stringRequiredOneOf(FORM_QUESTION_TYPES),
});

export const processFormQuestion = async (question: any): Promise<FormQuestion> => {
  return { ...question } as FormQuestion;
};

export const parseFormQuestion = async (object: any): Promise<FormQuestion | ProjectErrorType> => {
  try {
    if (await isValidYupSchema(FormQuestionSchema, object)) {
      return processFormQuestion(object);
    }
    return getProjectErrorForCode(ProjectErrors.invalidFormQuestion);
  } catch (error) {
    console.log(`[FORM QUESTIONS] ID: ${object?.id}. Error:`, error);
    return getProjectErrorFromRawError(error as Error);
  }
};

export const parseFormQuestions = async (items: any): Promise<FormQuestion[]> => {
  if (!(items && Array.isArray(items))) {
    console.log('[FORM QUESTIONS] Error: No array found.');
    return [];
  }

  const data: FormQuestion[] = [];
  for (const item of items) {
    const o = await parseFormQuestion(item);
    if (o && !isProjectError(o)) {
      data.push(o as FormQuestion);
    }
  }

  return data;
};
